import React from "react";
import { useRouteError, useNavigate } from "react-router-dom";
import { useTranslation } from "../hooks/useTranslation";

// react-router-dom's errorElement, wired up in routes.js. Distinct from
// ErrorBoundary.js (which catches render errors) — this catches errors
// thrown while a route's data/lazy chunk is resolving, most commonly a
// ChunkLoadError from a lazy-loaded route's script failing to fetch
// (e.g. a brief network blip). Reloading re-fetches the current chunk
// manifest, which is the actual fix for that case — retrying in place
// would just replay the same stale/failed import.
const RouteErrorFallback = () => {
  const error = useRouteError();
  const navigate = useNavigate();
  const { t } = useTranslation();

  // eslint-disable-next-line no-console
  console.error("Route error:", error);

  const message = error?.message || String(error || "");
  const isChunkLoadError = /ChunkLoadError|Loading chunk|Failed to fetch dynamically imported module/i.test(message);

  return (
    <div
      style={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 40,
        textAlign: "center",
        gap: 14,
      }}
    >
      <h2 style={{ margin: 0, fontSize: 24 }}>{t.routeErrorHeading}</h2>
      <p style={{ opacity: 0.75, maxWidth: 420, margin: 0 }}>
        {isChunkLoadError ? t.routeErrorChunkBody : t.routeErrorGenericBody}
      </p>
      <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            padding: "10px 20px",
            borderRadius: 8,
            border: "none",
            background: "#c67139",
            color: "#fff",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          {t.routeErrorReload}
        </button>
        <button
          type="button"
          onClick={() => navigate("/")}
          style={{
            padding: "10px 20px",
            borderRadius: 8,
            border: "1px solid rgba(32, 30, 29, 0.2)",
            background: "transparent",
            color: "inherit",
            cursor: "pointer",
          }}
        >
          {t.routeErrorGoHome}
        </button>
      </div>
    </div>
  );
};

export default RouteErrorFallback;
